import { Button } from "@/components/ui/button";
import { AnimatePresence } from "framer-motion";
import { useState } from "react";
import { DeleteMeModal } from "./DeleteMeModal";

export function DeleteMeButton() {
  const [openDeleteMeModal, setOpenDeleteMeModal] = useState(false);
  return (
    <>
      <Button
        className="w-fit"
        variant="destructive"
        onClick={() => setOpenDeleteMeModal(true)}
      >
        Delete account
      </Button>
      <AnimatePresence>
        {openDeleteMeModal && <DeleteMeModal setOpen={setOpenDeleteMeModal} />}
      </AnimatePresence>
    </>
  );
}
